import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import RefContainer from "csi/heading/RefContainer";
import Spec, { QuerySpec } from "csi/core/Spec";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

const CommentCategoriesRenderer = declare(RefContainer, {
	/**
	 * @override
	 * Don't filter by localized names
	 */
	getQuerySpec(ctx: Context, h: Heading, spec: Spec): QuerySpec {
		const qs = this.inherited<QuerySpec>(arguments);
		qs.blanksOperator = null;
		qs.id = xml.ATTR_NAME;
		qs.index = null;
		qs.notSortable = false;
		return qs;
	},

	/**
	 * @override
	 * Don't show localized names in drop-down
	 */
	getStoreOptions(ctx: Context, h: Heading): Record<string, any> {
		return { ignoreLocalizedName: true };
	},
});

export = CommentCategoriesRenderer;
